import React from 'react'
import { useDeskStyles } from './pageHeader.styles'
import clsx from 'clsx'
import { useLocation } from 'react-router'
import { Breadcrumbs, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { HOME_PATH, ROUTES_BAR } from 'routes/constants.routes'
import { Link } from 'react-router-dom'
import { useRoutes } from 'hooks'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'

const PageHeaderDesktop = ({ rightComponent, ...props }) => {
  let location = useLocation()
  const { t } = useTranslation()
  const { goTo } = useRoutes()
  const classes = useDeskStyles()
  const name = location.pathname?.replace('/', '')

  const routeKey =
    name &&
    Object.keys(ROUTES_BAR)?.find(key => name?.includes(key?.replace('/', '')))

  const routes = ROUTES_BAR[routeKey] || []
  const handleClick = path => () => {
    goTo(path)
  }
  return (
    <div className={classes.root}>
      {location.pathname !== HOME_PATH && (
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          {routes?.map((route, index, array) =>
            array.length - 1 === index ? (
              <Typography key={route?.path} color="textPrimary">
                {t(route?.title)}
              </Typography>
            ) : (
              <Link
                color="inherit"
                key={route?.path}
                onClick={handleClick(route?.path)}
              >
                {t(route?.title)}
              </Link>
            )
          )}
        </Breadcrumbs>
      )}
      <div
        className={clsx(
          classes.title,
          !!rightComponent && classes.titleWithRight
        )}
      >
        <Typography variant={'h5'} className={classes.typography}>
          {name && t(routes?.[routes?.length - 1]?.title)}
        </Typography>
        {!!rightComponent && rightComponent}
      </div>
    </div>
  )
}
export default PageHeaderDesktop
